export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getBannerList: function getBannerList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/banner/get",
        method: "get",
        params: data
      });
    },
    addBanner: function addBanner() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/banner/create",
        method: "post",
        data: data
      });
    },
    updateBanner: function updateBanner() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/banner/update",
        method: "post",
        data: data
      });
    },
    deleteBanner: function deleteBanner() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/banner/delete",
        method: "post",
        data: data
      });
    }
  };
});